<template>
    <list
        :title="$t(`pages.${ $options.module }.list.title`)"
        :count="list.length"
        :lang="lang"
        @new="newItem"
        @language="changeLang"
    >
        <template v-slot:default>
            <list-item
                v-for="item in list"
                :key="item.id"
                :config="$options.listItemConfig"
                :state="1"
                @edit="editItem(item.id)"
                @delete="removeItem(item.id)"
            >
                <img
                    v-if="getFlagUrl(item)"
                    :src="getFlagUrl(item)"
                    :alt="getItemTitle(item)"
                />
                {{ getItemTitle(item) }}
                <img class="ml-1" v-if="item.isincrisis" src="@/assets/images/icn-crisis.svg" alt="">
            </list-item>
        </template>
        <template v-slot:extras>
            <pop-down
                v-if="pop.active"
                :class="pop.className"
                @close="popClose"
            >
                {{ pop.message }}
            </pop-down>
            <modal
                v-if="remove.open"
                :title="$t(`pages.${ $options.module }.list.remove_title`)"
                :message="$t(`pages.${ $options.module }.list.remove_message`)"
                :cancelShow="true"
                :confirmLabel="$t(`pages.${ $options.module }.list.remove_confirm_label`)"
                @cancel="removeCancel"
                @confirm="removeConfirm"
            />
        </template>
    </list>
</template>

<script>
import ListMixin from '@/components/list/ListMixin';
import PopDownMixin from '@/components/PopDownMixin';
import api from '@/api';

export default {
    mixins: [ListMixin, PopDownMixin],
    name: 'CountriesList',
    module: 'countries',
    listItemConfig: {
        menu: true,
        changeState: false,
        edit: true,
        delete: true,
    },
    methods: {
        compareTitles(firstEl, secondEl) {
            const firstTitle = (typeof firstEl.locales[this.lang] !== 'undefined') ? firstEl.locales[this.lang].name.toUpperCase() : '(empty)';
            const secondTitle = (typeof secondEl.locales[this.lang] !== 'undefined') ? secondEl.locales[this.lang].name.toUpperCase() : '(empty)';
            if (firstTitle < secondTitle) {
                return -1;
            }
            if (firstTitle > secondTitle) {
                return 1;
            }

            return 0;
        },
        getItemTitle(item) {
            return item.locales[this.lang] ? item.locales[this.lang].name : '(empty)';
        },
        getFlagUrl(item) {
            if (typeof item.flagimageid !== 'undefined' && item.flagimageid > 0) {
                return api.image.url(item.flagimageid);
            }
            return null;
        },
    },
};
</script>
